import { useState, useEffect } from "react";
import TyltLogo from "@assets/logos/tylt_logo.png";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Logout from "@assets/icons/logout.svg";
import secureLocalStorage from "react-secure-storage";
import LogoutSlidingPanel from "@components/sliders/LogoutSlidingPanel";

type NavItem = {
  key: string;
  label: string;
  icon?: string;
  path: string;
  enabled: boolean;
};

const MobileLayout = () => {
  const navigate = useNavigate();
  const [isLogout, setIsLogout] = useState<boolean>(false);
  const location = useLocation();
  const currentPath = location.pathname;

  // Navigation items configuration
  const navItems: NavItem[] = [
    {
      key: "refund_requests",
      label: "Refund Requests",
      path: "/",
      enabled: true,
    },
  ];

  const getActiveTab = (path: string) => {
    if (path === "/") return "refund_requests";
    return "refund_requests";
  };

  const [activeTab, setActiveTab] = useState(getActiveTab(currentPath));

  useEffect(() => {
    setActiveTab(getActiveTab(currentPath));
  }, [currentPath]);

  const handleNavigation = (item: NavItem) => {
    if (item.enabled) {
      navigate(item.path);
      setActiveTab(item.key);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-bg-page-body">
      {/* Top Header */}
      <header className="flex justify-between items-center px-4 py-3 bg-bg-navbar border-b border-border-subtle">
        <img src={TyltLogo} alt="Tylt Logo" className="h-5" />
        <div className="p-2" onClick={() => setIsLogout(true)}>
          <img src={Logout} alt="Logout" className="w-6 h-6" />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 border-t border-border-navbar shadow-lg h-[84px] bg-bg-navbar flex justify-center items-center">
        <div className="flex justify-around">
          {navItems.map((item) => (
            <div
              className={`flex flex-col items-center justify-center rounded-lg h-[54px] w-[90px] cursor-pointer space-y-[4px] ${
                item.key === activeTab ? "bg-bg-page-body" : "bg-bg-navbar"
              }`}
              onClick={() => handleNavigation(item)}
            >
              <span className="font-semibold text-[12px] text-text-base leading-none text-center">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </nav>

      {/* Logout Panel */}
      <LogoutSlidingPanel
        isOpen={isLogout}
        onClose={() => setIsLogout(false)}
        type="send"
        onClickConfirm={() => {
          secureLocalStorage.clear();
          navigate("/login");
        }}
        sliderHeading="Logout"
      />
    </div>
  );
};

export default MobileLayout;
